<template>
  <div class="inventory-settings">
    
    <!-- General Settings -->
    <div v-if="activeTab === 'general'">
      <h6 class="mb-3">{{ $t('inventory_settings') }}</h6>
      <p class="text-muted mb-4 small">{{ $t('inventory_settings_description') }}</p>

      <!-- Price Includes Taxes Option -->
      <div class="card mb-4">
        <div class="card-body">
          <h6 class="card-title mb-3">
            <AppIcon name="bi-currency-dollar" class="bi bi-currency-dollar me-2" />
            {{ $t('pricing_settings') }}
          </h6>
          
          <div class="form-check form-switch mb-3">
            <input 
              class="form-check-input" 
              type="checkbox" 
              role="switch" 
              id="priceIncludesTaxes"
              v-model="priceIncludesTaxes"
              @change="savePricingSettings"
            >
            <label class="form-check-label" for="priceIncludesTaxes">
              {{ $t('price_includes_taxes') }}
            </label>
            <div class="form-text">
              {{ $t('price_includes_taxes_description') }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Products Table Column Visibility -->
    <div v-if="activeTab === 'columns'">
      <div class="card">
        <div class="card-body">
          <h6 class="card-title mb-3">
            <AppIcon name="bi-table" class="bi bi-table me-2" />
            {{ $t('products_table_columns') }}
          </h6>
          <p class="text-muted small mb-3">{{ $t('products_table_columns_description') }}</p>
          
          <div class="row g-3">
            <div class="col-md-4 col-sm-6" v-for="(column, key) in visibleColumns" :key="key">
              <div class="form-check form-switch">
                <input 
                  class="form-check-input" 
                  type="checkbox" 
                  :id="'col-' + key"
                  v-model="visibleColumns[key]"
                  @change="saveColumnSettings"
                >
                <label class="form-check-label" :for="'col-' + key">
                  {{ $t(getColumnLabel(key)) }}
                </label>
              </div>
            </div>
          </div>
         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from '../../helper'
import { getInventoryProductColumnDefaults } from '../../constants/inventoryProductColumns'

export default {
  name: 'InventorySettings',
  props: ['activeTab'],
  data() {
    return {
      priceIncludesTaxes: false,
      loading: false,
      visibleColumns: getInventoryProductColumnDefaults()
    }
  },
  async mounted() {
    await this.loadSettings();
  },
  methods: {
    getColumnLabel(key) {
      const labels = {
        reference: 'reference',
        image: 'image',
        sku: 'sku',
        label: 'product_label',
        inventories: 'inventories',
        supplier: 'supplier',
        category: 'category',
        purchase_price: 'purchase_price',
        price: 'price',
        profit_margin: 'profit_margin',
        quantity: 'quantity',
        min_quantity: 'min_quantity',
        warehouse: 'warehouse',
        status: 'status',
        created_by: 'created_by',
        created_at: 'created_at',
        action: 'action',
        barcode: 'barcode',
        has_variants: 'product_has_variants',
        notes: 'notes',
        unity: 'unity'
      };
      return labels[key] || key;
    },
    async loadSettings() {
      try {
        this.loading = true;
        const response = await helper.customGet(`${process.env.VUE_APP_API}/businesses`);
        
        if (response.data.business.metadata?.inventory_settings) {
          this.priceIncludesTaxes = response.data.business.metadata.inventory_settings.price_includes_taxes || false;
        }

        // Load column visibility settings
        if (response.data.business.metadata?.inventory_products_columns) {
          this.visibleColumns = {
            ...this.visibleColumns,
            ...response.data.business.metadata.inventory_products_columns
          };
        }
        
        this.loading = false;
      } catch (error) {
        this.$toast.error(error.message);
        this.loading = false;
      }
    },
    async savePricingSettings() {
      try {
        const response = await helper.customGet(`${process.env.VUE_APP_API}/businesses`);
        const business = response.data.business;
        
        if (!business.metadata) {
          business.metadata = {};
        }
        
        if (!business.metadata.inventory_settings) {
          business.metadata.inventory_settings = {};
        }
        
        business.metadata.inventory_settings.price_includes_taxes = this.priceIncludesTaxes;
        
        await helper.customPost(`${process.env.VUE_APP_API}/businesses`, business, { showToast: true });
        
      } catch (error) {
        this.$toast.error(error.message);
      }
    },
    async saveColumnSettings() {
      try {
        const response = await helper.customGet(`${process.env.VUE_APP_API}/businesses`);
        const business = response.data.business;
        
        if (!business.metadata) {
          business.metadata = {};
        }
        
        business.metadata.inventory_products_columns = this.visibleColumns;
        
        await helper.customPost(`${process.env.VUE_APP_API}/businesses`, business, { showToast: true });
        
      } catch (error) {
        this.$toast.error(error.message);
      }
    },
    async resetColumns() {
      this.visibleColumns = getInventoryProductColumnDefaults();
      await this.saveColumnSettings();
    }
  }
}
</script>

<style scoped>
.inventory-settings .card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.inventory-settings .card-title {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

/* .form-check-input:checked {
  background-color: #28a745;
  border-color: #28a745;
} */

.form-text {
  font-size: 0.875rem;
  color: #6c757d;
  margin-top: 0.25rem;
}
</style>
